import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './features/auth/AuthContext';
import { ThemeProvider } from './app/ThemeContext';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Dado financeiro nao pode aparecer velho: reconsulta ao voltar para a aba.
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // 401, 403 e 422 nao se resolvem repetindo.
        const status = (error as { status?: number })?.status;
        if (status && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/*
      O tema envolve TUDO, inclusive a tela de login e o "Carregando…".
      Dentro da checagem de sessão, essas duas telas ficariam claras para quem
      escolheu escuro — e são justamente as primeiras que aparecem.
    */}
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);